export const BASE_PATH = "nycbs_sftp_csv";
export const TABLE_PAGE_SIZE = 10;

export const currentYear = new Date().getFullYear();
export const currentMonth = String(new Date().getMonth() + 1).padStart(2, "0");

export const MONTH_OPTIONS = [
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
];

export const YEAR_OPTIONS = [currentYear, currentYear - 1, currentYear - 2];

export const DOWNLOAD_FILES_TABLE_KEYS = {
  FILE_NAME: "fileName",
  DOWNLOAD: "download",
} as const;

export const PENDING_TAB_ID = "pending";
export const RESPONSE_TAB_ID = "response";

export const DOWNLOAD_FILES_TABS = [
  { id: PENDING_TAB_ID, label: "Pending" },
  { id: RESPONSE_TAB_ID, label: "Response" },
] as const;

export interface FileItem {
  name: string;
  fullPath: string;
  downloadURL: string;
}
